# #########################################################
# @author Dana Luther <dluther@envisageinternational.com>
# #########################################################

# ##########################################################
# Shared common functions
# ##########################################################

# Animation for opening windows at a consistent style
animatedToggle = ( element, event, animationSpeed='fast' ) ->
  if element
    event.preventDefault()
    element.slideToggle animationSpeed, () ->
      if element.is ':visible'
        $('html, body').animate {scrollTop: element.offset().top}, 1000

animatedOpen = ( element, event, animationSpeed='fast' ) ->
  event.preventDefault()
  element.slideDown animationSpeed

animatedClose = ( element, event, animationSpeed='fast' ) ->
  event.preventDefault()
  element.slideUp animationSpeed

resetForm = ( form ) ->
  form.find ':input:visible:not(:submit, :disabled, .do-not-clear)' .each ->
    elem = $(this)
    if elem.is 'input' or elem.is 'textarea'
      switch elem.attr 'type'
        when 'checkbox' or 'radio' then elem.prop 'checked',false
        else
          elem.val ''
    else if elem.is 'select'
      elem.find 'option:selected'
        .prop 'selected', false


# Common Plan Widget Scripts
getToggleTitle = ( tog ) ->
  plan = tog.parents 'div.view'
  collapsed = $(tog).hasClass 'collapsed'
  tog.attr 'title',  if collapsed then 'Show Details' else 'Hide Details'
  if not collapsed then updateDays $(plan)

updateDays = ( container ) ->
  loading = '<i class="fa fa-cog fa-spin"></i>'

  if container .hasClass 'loaded' then return

  container.find '.totalDays, .upcomingDays, .usedDays'
    .html loading ;

  $.ajax
    url: container.attr 'data-url'
    dataType: 'json'
    context: container
    success: (data, textstatus, jqXHR ) ->
      $(this).find '.totalDays'
        .html data.totalDays
      $(this).find '.upcomingDays'
        .html data.upcomingDays
      $(this).find '.usedDays'
        .html data.usedDays
    error: ( jqXHR, textStatus, errorThrown ) ->
      $(this).find '.totalDays'
        .html "error #{errorThrown}"
      $(this).find '.upcomingDays'
        .html "error #{errorThrown}"
      $(this).find '.usedDays'
        .html "error #{errorThrown}"
  container.addClass 'loaded'


submitParticipantEditForm = () ->
  qty_participants = $("[data-key] input:checked").length
  fields = $('#participantmulti-selectedfields input:checked')

  if qty_participants != 1 then paxLabel = 'participants' else paxLabel = 'participant'
  if fields.length != 1 then fieldLabel = 'fields' else fieldLabel = 'field'
  prompt = "You are about to update the following "+fieldLabel+" on "+qty_participants+" "+paxLabel+": "

  fields.each (ix,item) ->
    if ix > 0 then prompt += ', '
    prompt += item.value

  prompt += '. Do you wish to continue?'

  return confirm prompt

# Make this available to other click toggles
openAndScroll = (tar, event, scroll_target) ->
  # Determine if the target is currently visible, so that we do not scroll to it if we're closing it
  wasOpen = $(tar).is ":visible"
  animatedToggle $(tar), event
  # Don't scroll down if the target isn't visible now
  if wasOpen then return false
  if scroll_target then $( scroll_target ).animate ( scrollTop: $(tar).offset().top ), 'fast'
  return false

# ##########################################################
# jQuery specific listeners and updates
# ##########################################################

# wrap in jQuery block
$ ->
  # Progressive enhancement
  $('body').addClass('js-enabled')

  # Enable search buttons and form closures
  $('.search-button, .search-link, form span.closeMe').click ( event ) ->
    animatedToggle $('.search-form'), event

  $('.history-link').click ( event ) ->
    animatedToggle $('.history'), event

  $('span.closeMe.targetted').click ( event ) ->
    tar = $(event.target).attr 'data-close'
    animatedToggle $(tar), event

  # Enable flash message closures
  $('div.flash span.closeMe').click ( event ) ->
    animatedClose $(event.target).parent(), event


  $('.btn-toggle').click ( event )->
    tar = $(this).attr 'data-toggle'
    scroll_target = $(this).attr 'data-scroll-target'
    if tar then openAndScroll tar, event, scroll_target
    return false

  $('.btn-reset').click ( event ) ->
    event.preventDefault()
    resetForm $(this).parents('form').eq(0);

  $('#search-form-link').click ( event ) ->
    openAndScroll '.search-form', event, 'body'

  # Use the on listener so that it will activate on ajax loaded content as well
  $( document ).on "click", "div.view span.toggle", ( event )->
      $(this).toggleClass 'collapsed'
      event.preventDefault()
      plan_sub = $( $(this).parents 'div.view' ).attr 'data-bs-target'
      animatedToggle $(plan_sub), event, 2
      getToggleTitle( $(this))

  $('[id^=collapse-sub-view-]').on 'show.bs.collapse', ( event )->
    updateDays $(this)

  $('#participant-edit-multi-form').submit ( event ) ->
    event.stopImmediatePropagation()
    return submitParticipantEditForm()

  # Global function so that we're not cluttering up with lots of specific ID listeners
  $('.btn-modal-submit').click ( event ) ->
    event.preventDefault()
    tar = $(this).attr 'data-bs-target'
    if tar then $(tar).submit() else alert "no target"

  $('.bar-graph-col').each ->
    heightVal = $(this).attr 'data-value'
    if not heightVal then return false
    $(this).animate ( height: heightVal ), 900

  $('.date-limitation-link').click ( event )->
    min_date = $(this).attr 'data-min'
    max_date = $(this).attr 'data-max'
    $('#participantsearchextended-search_start_dt_from').val(min_date)
    $('#participantsearchextended-search_start_dt_to').val(max_date)
    $('#participant-search-form').submit()

  # Toggle warning on table rows that are selected for bulk modification
  $('input:checkbox[name="selection[]"],input:checkbox[name="id[]"]').change ->
    checkbox = $(this)
    cbRow = checkbox.parents('tr:first')
    if checkbox.is ':checked'
      cbRow.addClass 'table-warning'
    else 
      cbRow.removeClass 'table-warning'
    return true

  return true
  #End jQuery Block

